import { MonitoringActivity } from 'types/apiModels'
import { apiClient } from '../../../ruutsApi/client'
import endpoints from '../../../ruutsApi/endpoints'
import { type ApiV2QueryType } from '../../../ruutsApi/types'
import { unwrapPaginated } from '../../../ruutsApi/normalize'

export default async function getMonitoringActivities({
  query,
  signal,
}: {
  query?: ApiV2QueryType<MonitoringActivity> & { farmId: string }
  signal?: AbortSignal
}) {
  const response = await apiClient.get(endpoints.v2.monitoring.activities, {
    params: query,
    signal,
  })
  return unwrapPaginated<MonitoringActivity>(response)
}
